import { c as _c } from "react/compiler-runtime";
import { captureException } from '@sentry/nextjs';
import classnames from 'classnames';
import QualitySeal from '../../QualitySeal';
import qualitySeals from '../../QualitySeal/quality-seals';
import type { SectionProps } from './section';
type Props = SectionProps & {
  qualitySealId: string;
};
const QualitySealSection = t0 => {
  const $ = _c(9);
  const {
    qualitySealId,
    classes: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const classes = t2;
  ;
  try {
    const qualitySeal = qualitySeals[qualitySealId];
    let t4;
    if ($[2] !== classes) {
      t4 = classnames(...classes);
      $[2] = classes;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    let t5;
    if ($[4] !== qualitySeal) {
      t5 = <QualitySeal qualitySeal={qualitySeal} />;
      $[4] = qualitySeal;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    let t6;
    if ($[6] !== t4 || $[7] !== t5) {
      t6 = <section className={t4}>{t5}</section>;
      $[6] = t4;
      $[7] = t5;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    return t6;
  } catch (t3) {
    const e = t3;
    captureException(new Error(`There was an error while rendering the quality seal for ID ${qualitySealId}: ${e}`), {
      level: "error"
    });
    return null;
  }
};
export default QualitySealSection;